export const footerItems = [
    {
        github: "https://github.com/ryelow94",
        facebook: "https://www.facebook.com/ryan.logan.984",
        email: "http://ryelow94@gmail.com",
        linkedIn: "http://www.linkedin.com/in/ryelow94"
    }
]